import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteObjectiveTemplates } from './Templates';
import { PatientCareCenterNoteWpObjectiveROM } from './ROM';
import { PatientCareCenterNoteObjectiveStr } from './Str';
import { PatientCareCenterNoteObjectiveCardio } from './Cardio';
import { PatientCareCenterNoteObjectiveBehavioral } from './Behavioral';
import { PatientCareCenterNoteObjectiveMaterialHandling } from './Mat';
import { PatientCareCenterNoteObjectiveNonMaterialHandling } from './NonMat';
import { PatientCareCenterNoteObjectiveOutMeasures } from './OutMeasures';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';

class PatientCareCenterNoteWpObjective extends React.Component {
    render() {
        return (
            <PatientCareCenterNoteSection id='objective' name='Objective' refProp={this.props.refProp} level={5}>
                {this.props.type !== 2 && this.props.type !== 4 && this.props.type !== 6 &&
                    <PatientCareCenterNoteObjectiveTemplates />
                }
                <PatientCareCenterNoteObjectiveCardio />
                <PatientCareCenterNoteWpObjectiveROM />
                <PatientCareCenterNoteObjectiveStr />
                <PatientCareCenterNoteObjectiveBehavioral />
                <PatientCareCenterNoteObjectiveMaterialHandling />
                <PatientCareCenterNoteObjectiveNonMaterialHandling />
                <PatientCareCenterNoteObjectiveOutMeasures outcomesRef={this.props.outcomesRef} /> 
            </PatientCareCenterNoteSection>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let type = parseInt(noteId.split("_")[0]);

    return {
        type,
    };
}

const connectedPatientCareCenterNoteWpObjective = connect(mapStateToProps)(PatientCareCenterNoteWpObjective);
export { connectedPatientCareCenterNoteWpObjective as PatientCareCenterNoteWpObjective };

